import React, { Component } from 'react';
import { matchPath } from 'react-router';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { ServicesProvider } from '@wix/experts-common';
import actions from './exploreActions';
import filterActions from './Filters/filterActions';
import Filters from './Filters/Filters';
import { ARENA_EXPLORE_URL } from '../../utils/constants';
import s from './explore.scss';
import ZeroState from './ZeroState/ZeroState';
import EmptyState from './EmptyState/EmptyState';
import ExpertsList from './ExpertsList/ExpertsList';
import Pagination from '../common/Pagination/Pagination';
import Tags from './Tags/Tags';
import { Loader, Text, Heading } from 'wix-style-react';
import isServer from '../../utils/isServer';
import * as seo from '../../utils/seo';

const mapStateToProps = (
  { explore, filters, router, experiments, initialData },
  ownProps,
) => {
  const isFilterApplied = !!ownProps.match.params.mainCategoryDisplayKey;
  return {
    isFilterApplied,
    experts: explore.experts,
    totalResults: explore.total,
    pageCount: explore.pagination.pageCount,
    page: explore.pagination.page,
    loading: explore.loading,
    isFiltersValid: explore.isFiltersValid,
    filters,
    urlFilters: explore.urlFilters,
    router,
    experiments,
    categories: initialData.categories,
    staticsBaseUrl: initialData.staticsBaseUrl,
    possibleLanguages: initialData.possibleLanguages,
    url: isServer ? initialData.url : window.location.href,
  };
};

class Explore extends Component {
  static fetchData(store, match, staticContext) {
    return store.dispatch(
      actions.initExploreScreen(
        match.params.mainCategoryDisplayKey,
        match.params.mainServiceDisplayKey,
        staticContext,
      ),
    );
  }

  getMatchPath = () =>
    matchPath(this.props.history.location.pathname, {
      path: `${ARENA_EXPLORE_URL}/:mainCategoryDisplayKey?/:mainServiceDisplayKey?`,
    });

  componentDidMount() {
    const match = this.getMatchPath();
    this.props.initExploreScreen(
      match && match.params ? match.params.mainCategoryDisplayKey : null,
      match && match.params ? match.params.mainServiceDisplayKey : null,
    );
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.router.location.pathname !==
        prevProps.router.location.pathname ||
      this.props.router.location.search !== prevProps.router.location.search
    ) {
      const match = this.getMatchPath();
      this.props.initExploreScreen(
        match && match.params ? match.params.mainCategoryDisplayKey : null,
        match && match.params ? match.params.mainServiceDisplayKey : null,
      );
    }
  }

  render() {
    const {
      t,
      isFilterApplied,
      isFiltersValid,
      experts,
      pageCount,
      page,
      onPageChange,
      loading,
      sendBiOnExpertProfileClick,
      onExpertProfileMinimalPriceClick,
      onServiceClick,
      onCategoryClick,
      onClearAllFilters,
      onFilterTagRemove,
      filters,
      urlFilters,
      totalResults,
      categories,
      staticsBaseUrl,
      url,
      possibleLanguages,
      match: {
        params: { mainCategoryDisplayKey, mainServiceDisplayKey },
      },
    } = this.props;

    return (
      <div data-hook="explore-screen-wrapper" className={s.root}>
        {seo.generateHelmet({
          possibleLanguages,
          title: !mainCategoryDisplayKey
            ? t('arena_explore_page_zero_state_seo_title')
            : t('arena_explore_page_seo_title', {
                categoryAndService: mainServiceDisplayKey
                  ? `${mainCategoryDisplayKey} | ${mainServiceDisplayKey}`
                  : `${mainCategoryDisplayKey}`,
              }),
          description: t('arena_explore_page_seo_description'),
          url,
          page,
          pageCount,
        })}
        <Heading appearance="H1" className={s.exploreSubHeader}>
          {t('client-exploreexperts-title-all')}
        </Heading>
        {loading && (
          <div className={s.exploreLoader} data-hook="explore-loader">
            <Loader size="medium" />
          </div>
        )}
        {isFilterApplied && isFiltersValid ? (
          experts.length ? (
            <div data-hook="explore-screen">
              <Filters />
              <Tags
                filters={urlFilters}
                onClear={onClearAllFilters}
                onTagRemove={onFilterTagRemove}
                possibleLanguages={possibleLanguages}
              />
              <ExpertsList
                experts={experts}
                total={totalResults}
                filters={filters}
                staticsBaseUrl={staticsBaseUrl}
                onExpertProfileClick={sendBiOnExpertProfileClick}
                onExpertProfileMinimalPriceClick={
                  onExpertProfileMinimalPriceClick
                }
              />
              <Pagination
                pageCount={pageCount}
                currentPage={page}
                onPageChange={onPageChange}
              />
              <div className={s.exploreFooter}>
                <Heading appearance="H2" className={s.header}>
                  {t('client-exploreexperts-footer-title')}
                </Heading>
                <Text
                  weight="normal"
                  size="medium"
                  secondary={false}
                  light={false}
                  className={s.subtitle}
                >
                  {t('client-exploreexperts-footer-subtitle')}
                </Text>
              </div>
            </div>
          ) : (
            <div>
              {!loading &&
                [
                  <Filters key={1} />,
                  <Tags
                    key={2}
                    filters={urlFilters}
                    onClear={onClearAllFilters}
                    onTagRemove={onFilterTagRemove}
                    possibleLanguages={possibleLanguages}
                  />,
                  <EmptyState
                    key={3}
                    filters={urlFilters}
                    staticsBaseUrl={staticsBaseUrl}
                  />,
                ].map(x => x)}
            </div>
          )
        ) : (
          <div>
            {!loading && (
              <ZeroState
                categories={categories}
                onServiceClick={onServiceClick}
                onCategoryClick={onCategoryClick}
                staticsBaseUrl={staticsBaseUrl}
              />
            )}
          </div>
        )}
      </div>
    );
  }
}

Explore.contextTypes = ServicesProvider.childContextTypes;

const ConnectedExplore = connect(mapStateToProps, {
  ...actions,
  ...filterActions,
})(Explore);

export default translate(null, { wait: !isServer })(ConnectedExplore);
